export { DefaultAvatar } from './DefaultAvatar';
